import { isBrowser } from './isBrowser';

export const pixieEvent = (eventName: string, data) => {
  if (isBrowser && window.pixie) {
    window.pixie('event', eventName, data || '');
    console.log('event', eventName, data || '');
  }
};
